<script setup>
import YTPlayer from '~/components/players/YTPlayer.vue'
import VimeoPlayer from '~/components/players/VimeoPlayer.vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => null
  },
  isFluid: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <div :class="{'col-span-12 lg:col-span-4 flex flex-col mt-8': !props.isFluid}">
    <h3 class="text-lg font-bold upp">{{ data.title }}</h3>
    <YTPlayer v-if="data.source === 'youtube'" :video-id="data.id"/>
    <VimeoPlayer v-else-if="data.source === 'vimeo'" :video-id="data.id"/>
    <div v-else class="text-center font-semibold">
      Formato de vídeo no soportado
    </div>
  </div>
</template>
